var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40909 16.6818C7.30909 16.6818 8.04546 15.9454 8.04546 15.0454H4.77273C4.77273 15.9454 5.50909 16.6818 6.40909 16.6818Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95455 14.2272H8.86364C9.31364 14.2272 9.68182 13.859 9.68182 13.409C9.68182 12.959 9.31364 12.5908 8.86364 12.5908H3.95455C3.50455 12.5908 3.13636 12.959 3.13636 13.409C3.13636 13.859 3.50455 14.2272 3.95455 14.2272Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40909 0.318115C3.02182 0.318115 0.272728 3.06721 0.272728 6.45448C0.272728 9.57993 2.44909 11.249 3.35727 11.7727H9.46091C10.3691 11.249 12.5455 9.57993 12.5455 6.45448C12.5455 3.06721 9.79636 0.318115 6.40909 0.318115Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightBulb);
export default __webpack_public_path__ + "static/media/ic_lightBulb.0b4bb73362652e3cc026280ec9dad018.svg";
export { ForwardRef as ReactComponent };